// Entity ids are GUID strings. A few sentinels survive from the numeric ids:
// NO_ID ('-1') means "none" (the "all" entry of a filter, nothing selected), and negative numbers
// ('-2', '-3', ...) mark items created on the page but not saved yet. The server reads all of them as an empty id.
export var NO_ID = '-1';
var EMPTY_GUID = '00000000-0000-0000-0000-000000000000';
/** True for the id of a saved entity. */
export function hasId(id) {
    return !!id && id !== EMPTY_GUID && !isNumericSentinel(id);
}
/** True for an item created on the page and not saved yet. */
export function isNewId(id) {
    return !!id && isNumericSentinel(id) && Number(id) < -1;
}
/** A temporary id for a new item, distinct from the temporary ids already in use. */
export function newTempId(existingIds) {
    var minId = -1;
    for (var _i = 0, existingIds_1 = existingIds; _i < existingIds_1.length; _i++) {
        var id = existingIds_1[_i];
        if (isNumericSentinel(id))
            minId = Math.min(minId, Number(id));
    }
    return String(minId - 1);
}
function isNumericSentinel(id) {
    return /^-?\d+$/.test(id) && Number(id) <= 0;
}
